(function(){
  'use strict'

    angular.module('clooper')
        .directive('whitepaper', whitepaperDirective)

    WhitepaperController.$inject = ['$scope', '$element', '$compile', '$window', '$timeout']
    /* ngInject */
    function WhitepaperController($scope, $element, $compile, $window, $timeout) {
        var vm = this;

        vm.modal = `
        <div class="modal whitepaper-modal fade">
          <div class="modal-dialog modal-dialog-centered modal-xs" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <form wp-ajax-form captcha-action="dowloads" post-id="{{vm.whitepaper.id}}" post-action="process_download" post-type="whitepaper" post-nonce="whitepaper_nonce">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button> 
                  <h3>Just one more thing...</h3>
                  <p>Fill the details below and you can access the whitepaper straight away!</p>
                  <div class="form-group">
                    <label>Your First Name</label>
                    <input type="text" placeholder="First Name" class="form-control" ng-model="vm.data.name" required>
                  </div>
                  <div class="form-group">
                    <label class="required">Your Email Address</label>
                    <input type="email" placeholder="Email" class="form-control" ng-model="vm.data.email" required>
                  </div>
                  <div class="form-group response-placeholder">
                    <button class="btn btn-block btn-secondary">Download Now</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        `;

        $element.on('click', function () {
          vm.whitepaper = JSON.parse(vm.post);
          const compiledHtml = $compile(vm.modal)($scope);
          angular.element(compiledHtml).appendTo('body').modal({ show: true, backdrop: 'static' });
          $(compiledHtml).on('success', 'form', function(event, data) {
            const link = document.createElement('a');
            link.setAttribute('href', vm.whitepaper.file);
            link.setAttribute('download', 'download')
            document.querySelector('body').appendChild(link);
            link.click();
            $timeout(function(){
              angular.element('.modal').modal('hide');
              link.remove();
            }, 1000);
          })
          if (typeof grecaptcha === 'undefined') {
            $.getScript('https://www.google.com/recaptcha/api.js?render=' + $window.clooper.RECAPTCHA_SITE_KEY)
          }
        })

    }

    function whitepaperDirective(){
      return {
        controller:WhitepaperController,
        controllerAs:'vm',
        scope:true,
        restrict:'EA',
        bindToController:{
          post: '@post'
        }
      }
    }

})()
